import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { take } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class LandingComponent {
  constructor(
    public auth: AuthService,
    private router: Router,
    private titleService: Title
  ) {
    // On landing, check if user is logged in and redirect to /projects if so
    this.auth.user$.pipe(take(1)).subscribe((user) => {
      if (user) {
        this.router.navigate(['/projects']);
      }
    });
    this.titleService.setTitle(
      'Welcome | Cannonball Project Management Portal'
    );
  }

  async signIn() {
    console.error('[DEBUG] LOGIN BUTTON CLICKED');
    try {
      const user = await this.auth.signInWithGoogle();
      console.log('Successfully signed in');

      // Popup always returns user, navigate immediately
      if (user) {
        this.router.navigate(['/projects']);
      }
    } catch (error) {
      console.error('Sign in error:', error);
      // Error is already displayed via auth.authError in the template
    }
  }

  async signOut() {
    try {
      await this.auth.signOut();
      console.log('Successfully signed out');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  }
}
